
  document.addEventListener("DOMContentLoaded", function () {
    const showAllButton = document.querySelector("#button-media-show-all");

    if (showAllButton) {
      showAllButton.addEventListener("click", function () {
        document.querySelectorAll(".media-position-hide").forEach((element) => {
          element.style.display = "block";
        });

        showAllButton.style.display = "none";
      });
    }
  });

